import { render, staticRenderFns } from "./BrightSL.vue?vue&type=template&id=498282f2"
import script from "./BrightSL.vue?vue&type=script&lang=js"
export * from "./BrightSL.vue?vue&type=script&lang=js"
import style0 from "./BrightSL.vue?vue&type=style&index=0&id=498282f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports